// Winter log observations, grouped the way the crew sees them.
// An option with `field` is one of the original checkbox columns; an option
// with `code` is stored in the `observations` list. Codes must match
// backend/utils/winter-log-options.js. Labels live under winterLogs.*.

export const WEATHER_CATEGORIES = [
  {
    key: 'skySnowfall',
    showSnowIntensity: true,
    options: [
      { field: 'is_clear', label: 'clear' },
      { field: 'is_snowing', label: 'snowing' },
      { code: 'scattered_flurries', label: 'obs.scatteredFlurries' },
    ],
  },
  {
    key: 'freezingPrecipitation',
    options: [
      { field: 'is_freezing_rain', label: 'freezingRain' },
      { code: 'freezing_drizzle', label: 'obs.freezingDrizzle' },
      { code: 'sleet_ice_pellets', label: 'obs.sleetIcePellets' },
    ],
  },
  {
    key: 'changingConditions',
    options: [
      { code: 'rain_to_snow', label: 'obs.rainToSnow' },
      { code: 'snow_to_rain', label: 'obs.snowToRain' },
    ],
  },
  {
    key: 'wind',
    options: [
      { field: 'is_drifting', label: 'drifting' },
    ],
  },
];

export const PAVEMENT_CATEGORIES = [
  {
    key: 'snowSlush',
    options: [
      { field: 'is_snow', label: 'snow' },
      { code: 'packed_snow', label: 'obs.packedSnow' },
      { field: 'is_slushy', label: 'slushy' },
      { code: 'freezing_slush', label: 'obs.freezingSlush' },
    ],
  },
  {
    key: 'ice',
    options: [
      { field: 'is_icy', label: 'icy' },
      { code: 'black_ice', label: 'obs.blackIce' },
      { code: 'ice_buildup', label: 'obs.iceBuildup' },
      { code: 'refreeze_risk', label: 'obs.refreezeRisk' },
    ],
  },
  {
    key: 'clearWet',
    options: [
      { field: 'is_clear', label: 'clear' },
      { field: 'is_wet', label: 'wet' },
      { code: 'standing_water', label: 'obs.standingWater' },
    ],
  },
  {
    key: 'visibilityAccess',
    options: [
      { code: 'snowbanks_restricted_visibility', label: 'obs.snowbanksRestrictedVisibility' },
    ],
  },
];

export const SNOW_INTENSITIES = ['light', 'medium', 'heavy'];

export const ADDITIONAL_SERVICES = [
  { code: 'site_check', label: 'obs.siteCheck' },
  { code: 'salt_bin_refill', label: 'obs.saltBinRefill' },
];
